module.exports = __webpack_public_path__ + "svg_80x80/awslamda.384fea.svg";